// Estado de workspace do overhaul Atlas Vivo (docs/plans/overhaul-ux-atlas-vivo.md,
// fase 1.3). Extraído como reducer isolado e testável, ainda não conectado a
// App.js — a integração acontece na fase 2 (AtlasVivoShell), atrás da flag
// `atlasVivo`. Quatro eixos, conforme convenção do plano: view, period,
// selection, activeLenses. Só uma seleção por vez (nunca uma pilha).

import { useReducer, useCallback } from 'react';

export const WORKSPACE_VIEWS = ['atlas', 'dia', 'historias', 'dados'];

export const initialWorkspaceState = {
  view: 'atlas',
  period: null,
  selection: null,
  activeLenses: [],
};

export function workspaceReducer(state, action) {
  switch (action.type) {
    case 'SET_VIEW': {
      if (!WORKSPACE_VIEWS.includes(action.view)) return state;
      return { ...state, view: action.view };
    }
    case 'SET_PERIOD':
      return { ...state, period: { start: action.start, end: action.end } };
    case 'SET_SELECTION':
      return { ...state, selection: action.selection };
    case 'CLEAR_SELECTION':
      return { ...state, selection: null };
    case 'TOGGLE_LENS': {
      const has = state.activeLenses.includes(action.lens);
      return {
        ...state,
        activeLenses: has
          ? state.activeLenses.filter((lens) => lens !== action.lens)
          : [...state.activeLenses, action.lens],
      };
    }
    case 'SET_LENSES':
      return { ...state, activeLenses: [...action.lenses] };
    case 'RESET':
      return initialWorkspaceState;
    default:
      return state;
  }
}

export function useWorkspaceState(initialState = initialWorkspaceState) {
  const [state, dispatch] = useReducer(workspaceReducer, initialState);

  const setView = useCallback((view) => dispatch({ type: 'SET_VIEW', view }), []);
  const setPeriod = useCallback(
    (start, end) => dispatch({ type: 'SET_PERIOD', start, end }),
    []
  );
  const setSelection = useCallback(
    (selection) => dispatch({ type: 'SET_SELECTION', selection }),
    []
  );
  const clearSelection = useCallback(() => dispatch({ type: 'CLEAR_SELECTION' }), []);
  const toggleLens = useCallback((lens) => dispatch({ type: 'TOGGLE_LENS', lens }), []);
  const setLenses = useCallback((lenses) => dispatch({ type: 'SET_LENSES', lenses }), []);
  const reset = useCallback(() => dispatch({ type: 'RESET' }), []);

  return {
    state,
    dispatch,
    setView,
    setPeriod,
    setSelection,
    clearSelection,
    toggleLens,
    setLenses,
    reset,
  };
}
